import React, {useState, useEffect} from 'react';
import LikeButton from '../Shared/LikeButton';
import Modal from '../Modal';
import CitationModal from './Modal/CitationModal';

const FeatureBar = ({article, currentUserId, initialLikeId, initialLikeCount, setArticleLikeCount, setArticleLikeId, cssClass, preview, page, fireAmplitude, addPdfModalListener}) => {

  const target = preview ? '_self' : '_blank'

  useEffect(() => {
    addPdfModalListener("pdf-feature-bar");
  }, []);

  const openCitationModal = () => {
    Modal.open({
      children: <CitationModal
                  article={article}
                  fireAmplitude={fireAmplitude}
                />
    });
  }

  return (
    <div className={"feature-bar " + cssClass}>
      {!preview && page == 'article' && <LikeButton key={"topSection" + initialLikeId}
        currentUserId={currentUserId}
        likableId={article.id}
        initialLikeId={initialLikeId}
        initialLikeCount={initialLikeCount}
        setArticleLikeCount={setArticleLikeCount}
        setArticleLikeId={setArticleLikeId}
        containerType="featureBar"
        likableType={"Article"}
      />}
      <div className="icon-background feature-bar-styles">
        <a href={article.pdf_link} target={target} id="pdf-feature-bar">
          <img className="st-custom-button icon has-tip tip-top" data-tooltip="" title="Download PDF" src="https://public.cureus.com/article-show-redesign/pdf-icon-2.png" />
        </a>
      </div>
      {!preview && <>
        <div className="icon-background feature-bar-styles">
          <img className="st-custom-button icon feature-bar-icons has-tip tip-top" data-tooltip="" title="Download citation" src="https://public.cureus.com/article-show-redesign/citation-sharebar-icon.png" onClick={openCitationModal} />
        </div>
        <div className="icon-background feature-bar-styles">
          <img className="st-custom-button icon feature-bar-icons has-tip tip-top" onClick={() => fireAmplitude('articleShared', {article_id: article.id, medium: 'email'})} data-tooltip="" title="Share via email" src="https://public.cureus.com/article-show-redesign/mail-sharebar-icon.png" data-network="email" data-email-subject={`${article.title}`} data-url={article.path}/>
        </div>
        <div className="icon-background feature-bar-styles">
          <img className="st-custom-button icon feature-bar-icons has-tip tip-top" onClick={() => fireAmplitude('articleShared', {article_id: article.id, medium: 'sharethis'})} data-tooltip="" title="Select sharing option" src="https://public.cureus.com/article-show-redesign/share-sharebar-icon.png" data-network="sharethis" data-url={article.path} />
        </div>
        <div className="icon-background feature-bar-styles">
          <img className="st-custom-button icon feature-bar-icons has-tip tip-top" onClick={() => fireAmplitude('articleShared', {article_id: article.id, medium: 'reddit'})} data-tooltip="" title="Share on Reddit" src="https://public.cureus.com/article-show-redesign/reddit-icon.png" data-network="reddit" data-url={article.path} />
        </div>
        <div className="icon-background feature-bar-styles">
          <img className="st-custom-button icon feature-bar-icons facebook has-tip tip-top" onClick={() => fireAmplitude('articleShared', {article_id: article.id, medium: 'facebook'})} data-tooltip="" title="Share on Facebook" src="https://public.cureus.com/article-show-redesign/facebook-sharebar-icon.png" data-network="facebook" data-url={article.path} />
        </div>
        <div className="icon-background feature-bar-styles">
          <img className="st-custom-button icon feature-bar-icons twitter has-tip tip-top" onClick={() => fireAmplitude('articleShared', {article_id: article.id, medium: 'twitter'})} data-tooltip="" title="Share on Twitter" src="https://public.cureus.com/article-show-redesign/x-twitter-sharebar-icon.png" data-network="twitter" data-url={article.path} />
        </div>
      </>}
    </div>
  )
}

export default FeatureBar;